module.exports = __webpack_public_path__ + "media/svg-new/icon-portugues-fc9ce95a.svg";